import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const NAV = [
  { label: "Home", to: "/" },
  { label: "Story", to: "/story" },
  { label: "Products", to: "/products" },
  { label: "Contact", to: "/contact" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  return (
    <nav
      data-testid="main-navbar"
      className={`fixed top-0 w-full z-50 backdrop-blur-md border-b transition-all duration-300 ${
        scrolled
          ? "bg-cream/95 border-ink/10 shadow-[0_1px_0_rgba(1,1,1,0.04)]"
          : "bg-cream/80 border-transparent"
      }`}
    >
      <div className="px-6 sm:px-12 lg:px-24 py-3 flex items-center justify-between">
        <Link
          to="/"
          data-testid="nav-logo"
          className="flex items-center group"
        >
          <img
            src="/logo-goodspoon.png"
            alt="The Good Spoon"
            className="h-11 sm:h-14 w-auto transition-transform duration-300 group-hover:scale-[1.03]"
          />
        </Link>

        <div className="hidden md:flex items-center gap-10">
          {NAV.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              data-testid={`nav-link-${item.label.toLowerCase()}`}
              className={`font-primary text-sm font-medium transition-colors duration-200 ${
                pathname === item.to
                  ? "text-coral"
                  : "text-ink/70 hover:text-ink"
              }`}
            >
              {item.label}
            </Link>
          ))}
          <Link to="/products" data-testid="nav-cta" className="btn-primary !px-6 !py-3">
            Shop Spices
          </Link>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden text-ink"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="md:hidden bg-cream border-t border-ink/10 px-6 py-8 flex flex-col gap-6"
        >
          {NAV.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              data-testid={`mobile-nav-link-${item.label.toLowerCase()}`}
              className={`font-primary text-base font-medium ${
                pathname === item.to ? "text-coral" : "text-ink/80"
              }`}
            >
              {item.label}
            </Link>
          ))}
          <Link to="/products" className="btn-primary self-start mt-2">
            Shop Spices
          </Link>
        </div>
      )}
    </nav>
  );
};
